<template>
	<jr-echarts ref="echartsRef" :options="chartOptions" :height="height" :width="width" />
</template>

<script>
	import JrEcharts from './index.vue'

	// 企业人员结构分析
	export default {
		name: 'EnterprisePieChart',
		components: {
			JrEcharts
		},
		props: {
			width: {
				type: String,
				default: '100%'
			},
			height: {
				type: String,
				default: '350px'
			},
			chartData: {
				type: Array,
				required: true
			},

			// 是否显示图例
			showLegend: {
				type: Boolean,
				default: true
			},

			// 是否显示标签
			showLabel: {
				type: Boolean,
				default: false
			},
			// 饼图半径
			radius: {
				type: [String, Array],
				default: '70%'
			},
			// 饼图中心位置
			center: {
				type: Array,
				default: () => ['50%', '50%']
			},
			// 颜色列表
			colorList: {
				type: Array,
				default: () => []
			}
		},
		data() {
			return {}
		},
		computed: {
			chartOptions() {
				return {
					title: null,
					tooltip: {
						trigger: 'item',
						formatter: '{a} <br/>{b}: {c} ({d}%)'
					},
					legend: this.showLegend
						? {
								orient: 'vertical',
								right: 10,
								top: 'middle',
								icon: 'circle',
								itemWidth: 10,
								itemHeight: 10,
								textStyle: {
									fontSize: 12
								}
						  }
						: null,
					color:
						this.colorList.length > 0
							? this.colorList
							: [
									'#1890ff', // 蓝色
									'#13c2c2', // 青色
									'#722ed1', // 紫色
									'#fa8c16', // 橙色
									'#8c8c8c', // 灰色
									'#eb2f96', // 粉色
									'#faad14', // 黄色
									'#52c41a', // 绿色
									'#f5222d', // 红色
									'#2f54eb' // 深蓝色
							  ],
					series: [
						{
							name: '人员结构分析',
							type: 'pie',
							radius: this.radius,
							center: this.center,
							avoidLabelOverlap: true,
							label: {
								show: this.showLabel,
								position: 'outside',
								fontSize: 14,
								formatter: '{b}: {d}%'
							},
							labelLine: {
								show: this.showLabel,
								showAbove: false
							},
							emphasis: {
								itemStyle: {
									shadowBlur: 10,
									shadowOffsetX: 0,
									shadowColor: 'rgba(0, 0, 0, 0.5)'
								}
							},
							data: this.chartData
						}
					]
				}
			}
		},
		watch: {},
		created() {},
		mounted() {},
		methods: {}
	}
</script>

<style lang="scss" scoped></style>
